let countDownInterval = null;
let countUpInterval = null;

export default function switchBadgeCounter(animateMethod, list, interval) {
  if (!animateMethod || !list || !interval) {
    clearInterval(countDownInterval);
    clearInterval(countUpInterval);
    return;
  }
  let counter = 0;
  const countDown = () => {
    counter -= 1;
    countDownInterval = setInterval(() => {
      if (counter === 0) {
        clearInterval(countDownInterval);
        // eslint-disable-next-line no-use-before-define
        countUp();
      }
      animateMethod(0);
    }, interval);
  };
  let countUp = () => {
    counter += 1;
    countUpInterval = setInterval(() => {
      if (counter === list.length - 1) {
        clearInterval(countUpInterval);
        countDown();
      }
      animateMethod(1);
    }, interval);
  };
  countUp();
}
